import { postMessageToIframeParent } from "./iframeMessaging.ts";

const iframeGoHome = () => {
  postMessageToIframeParent({ type: "goHome" });
};

export default iframeGoHome;
